<script>
export default {
  name: "DidoDownloadItemAttachment",
};
</script>

<script setup>
import DidoDownloadButtonAttachment from "../buttons/Attachment.vue";

// define Props
const props = defineProps({
  attachment: { type: Object, required: true },
  selectable: { type: Boolean, required: false, default: false },
  selectedLinks: { type: Array, required: false, default: () => [] },
});

// define Emits
defineEmits(["update-selected-links"]);
</script>

<template>
  <QItem>
    <!-- Icon -->
    <QItemSection avatar title="Fichier joint">
      <QIcon name="mdi-paperclip" size="xs" color="secondary" />
    </QItemSection>
    <!-- Title -->
    <QItemSection>
      <QItemLabel
        class="text-secondary"
        lines="1"
        :title="props.attachment.description"
      >
        {{ props.attachment.title }}
      </QItemLabel>
    </QItemSection>
    <!-- Download Button -->
    <QItemSection side>
      <DidoDownloadButtonAttachment
        :attachment="props.attachment"
        :selectable="props.selectable"
        :selected-links="props.selectedLinks"
        @update-selected-links="$emit('update-selected-links', $event)"
      />
    </QItemSection>
  </QItem>
</template>
